module.exports = __webpack_public_path__ + "static/media/lidl.6c950308.png";